<template>
  <div>
    <div class="pb-6 border-brand-sand border-b-2">
      <p class="title mb-2 capitalize">{{ providerDisplay }} Settings</p>
      <p class="subtitle mt-2 text-lg font-medium text-brand-brown">
        Settings for how Churnkey interacts with your <span class="capitalize"> {{ providerDisplay }}</span> account.
      </p>
      <div class="pb-6 border-brand-sand border-b-2">&nbsp;</div>
      <OrgPaymentProviderConfig />
      <OrgPlanEditor class="mt-12" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import OrgPaymentProviderConfig from '@/components/Settings/OrgPaymentProviderConfig.vue';
import OrgPlanEditor from '@/components/Settings/OrgPlanEditor.vue';

export default Vue.extend({
  name: 'OrgPaymentProviderSettings',
  components: {
    OrgPaymentProviderConfig,
    OrgPlanEditor,
  },
  computed: {
    provider() {
      return this.$store.getters.providerWithVersion; // discerns 'paddle' and 'paddle_billing'
    },
    providerDisplay() {
      return this.$store.getters.provider; // Both paddle versions return 'paddle'
    },
  },
});
</script>
